import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ConceptSheet } from './components/ConceptSheet.js';
import { Layout, Toasts } from './components/Layout.js';
import { TransactionEditor } from './components/TransactionEditor.js';
import { AlertsPage } from './pages/Alerts.js';
import { ConceptsPage } from './pages/Concepts.js';
import { GridPage } from './pages/Grid.js';
import { MonthlyPage } from './pages/Monthly.js';
import { ProjectionPage } from './pages/Projection.js';
import { ReceivablesPage } from './pages/Receivables.js';
import { LoginPage, SetupPage } from './pages/Setup.js';
import { RulesPage, SettingsPage, SyncPage } from './pages/System.js';
import { TransactionsPage } from './pages/Transactions.js';
import { WeekendsPage } from './pages/Weekends.js';
import { AppProvider, useApp } from './state.js';
import { api } from './api.js';

function Shell() {
  const { loading, error, balance, period, setPeriod, conceptSheetId, closeConcept, needsHousehold, needsLogin, refresh, userKey } = useApp();
  const [quick, setQuick] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (!needsHousehold && !needsLogin && !loading) api.saveCheckpoint(userKey, { lastPage: location.pathname }).catch(() => undefined);
  }, [location.pathname, needsHousehold, needsLogin, loading, userKey]);
  if (loading) {
    return (
      <Layout>
        <div className="panel">
          <div className="skeleton" />
          <div className="skeleton" style={{ width: '60%' }} />
          <div className="skeleton" style={{ width: '80%' }} />
        </div>
      </Layout>
    );
  }
  if (needsLogin) return <LoginPage />;
  if (needsHousehold) return <SetupPage />;
  if (error) {
    return (
      <Layout>
        <div className="notice error">
          <div>
            <strong>No se pudo cargar el balance</strong>
            <div>{error}</div>
          </div>
          <button type="button" className="button" onClick={() => void refresh()}>
            Reintentar
          </button>
        </div>
      </Layout>
    );
  }
  const tools = (
    <>
      {balance ? (
        <select aria-label="Mes" value={period} onChange={(e) => setPeriod(e.target.value)} style={{ width: 'auto', margin: 0 }}>
          {balance.periods.map((p) => (
            <option key={p.period} value={p.period}>
              {p.label}
            </option>
          ))}
        </select>
      ) : null}
      <button type="button" className="button primary" onClick={() => setQuick(true)}>
        + Cargar gasto
      </button>
    </>
  );
  return (
    <Layout tools={tools}>
      <Routes>
        <Route path="/" element={<MonthlyPage />} />
        <Route path="/grilla" element={<GridPage />} />
        <Route path="/proyeccion" element={<ProjectionPage />} />
        <Route path="/movimientos" element={<TransactionsPage />} />
        <Route path="/revisar" element={<AlertsPage />} />
        <Route path="/conceptos" element={<ConceptsPage />} />
        <Route path="/conceptos/:tab" element={<ConceptsPage />} />
        <Route path="/fines-de-semana" element={<WeekendsPage />} />
        <Route path="/por-recuperar" element={<ReceivablesPage />} />
        <Route path="/reglas" element={<RulesPage />} />
        <Route path="/sincronizacion" element={<SyncPage />} />
        <Route path="/configuracion" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {quick ? <TransactionEditor transactionId={null} onClose={() => setQuick(false)} /> : null}
      {conceptSheetId ? <ConceptSheet id={conceptSheetId} onClose={closeConcept} /> : null}
    </Layout>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Shell />
        <Toasts />
      </AppProvider>
    </BrowserRouter>
  );
}
